import { put, call, takeLatest } from "redux-saga/effects";
import {
  getpendingorderRequest,
  getpendingorderSuccess,
  getpendingorderFailure,
  getprocessingorderRequest,
  getprocessingorderSuccess,
  getprocessingorderFailure,
  getshippedorderRequest,
  getshippedorderSuccess,
  getshippedorderFailure,
  getdeliveredorderRequest,
  getdeliveredorderSuccess,
  getdeliveredorderFailure,
  getallorderRequest,
  getallorderSuccess,
  getallorderFailure,
  updateorderstatusRequest,
  updateorderstatusSuccess,
  updateorderstatusFailure,
} from "./Order-slice";
import sellerApi from "../../utils/sellerApi";

function* getpendingordersaga(action) {
  try {
    const response = yield sellerApi.get(`getPendingOrders`, {
      params: action.payload,
    });
    yield put(getpendingorderSuccess(response.data));
  } catch (error) {
    yield put(getpendingorderFailure(error.message));
  }
}

export function* watchgetpendingordersaga() {
  yield takeLatest(getpendingorderRequest.type, getpendingordersaga);
}

function* getprocessingordersaga(action) {
  try {
    const response = yield sellerApi.get(`getProcessingOrders`, {
      params: action.payload,
    });
    yield put(getprocessingorderSuccess(response.data));
  } catch (error) {
    yield put(getprocessingorderFailure(error.message));
  }
}

export function* watchgetprocessingordersaga() {
  yield takeLatest(getprocessingorderRequest.type, getprocessingordersaga);
}

function* getshippedordersaga(action) {
  try {
    const response = yield sellerApi.get(`getShippedOrders`, {
      params: action.payload,
    });
    yield put(getshippedorderSuccess(response.data));
  } catch (error) {
    yield put(getshippedorderFailure(error.message));
  }
}

export function* watchgetshippedordersaga() {
  yield takeLatest(getshippedorderRequest.type, getshippedordersaga);
}

function* getdeliveredordersaga(action) {
  try {
    const response = yield sellerApi.get(`getDeliveredOrders`, {
      params: action.payload,
    });
    yield put(getdeliveredorderSuccess(response.data));
  } catch (error) {
    yield put(getdeliveredorderFailure(error.message));
  }
}

export function* watchgetdeliveredordersaga() {
  yield takeLatest(getdeliveredorderRequest.type, getdeliveredordersaga);
}

function* getallordersaga(action) {
  try {
    const response = yield sellerApi.get(`seller/orders`, {
      params: action.payload,
    });
    yield put(getallorderSuccess(response.data));
  } catch (error) {
    yield put(getallorderFailure(error.message));
  }
}

export function* watchgetallordersaga() {
  yield takeLatest(getallorderRequest.type, getallordersaga);
}

function* updateorderstatussaga(action) {
  try {
    const { orderId, orderItemId, new_status, note } = action.payload || {};
    const response = orderId && orderItemId
      ? yield sellerApi.put(
          `seller/orders/${orderId}/items/${orderItemId}/status`,
          { status: new_status, note }
        )
      : yield sellerApi.post(`updateOrderStatus`, action.payload);
    yield put(updateorderstatusSuccess(response.data));
  } catch (error) {
    yield put(updateorderstatusFailure(error.message));
  }
}

export function* watchupdateorderstatussaga() {
  yield takeLatest(updateorderstatusRequest.type, updateorderstatussaga);
}
